import React from 'react';
import {Alert, AlertTitle, Snackbar} from '@mui/material';
import { Home,Build } from '@mui/icons-material';
import DeveloperContainer from '../others-component/DeveloperContainer';
import Footer from '../utils/footer';
import Header from '../utils/header';
import { Page } from '../utils/datautils';

export default function Developer() {
    const[error,setError] = React.useState();
    const[response,setResponse] = React.useState();

    return(
      <>
        <Header path1={Page.HOME} path2={Page.ADMIN} icon1={<Home />} icon2={<Build />}
          desc1='Home' desc2='Data Center'/>
        <div style={{height:'60px'}}/>
        <DeveloperContainer setResponse={setResponse} setError={setError}/>
        <Footer />
        <Snackbar open={Boolean(error)} anchorOrigin={{vertical:'top', horizontal:'center'}} autoHideDuration={3000} onClose={a => setError(null)}>
          <Alert severity='error' onClose={a => setError(null)}>
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        </Snackbar>
        <Snackbar open={Boolean(response)} anchorOrigin={{vertical:'top', horizontal:'center'}} autoHideDuration={3000} onClose={a => setResponse(null)}>
          <Alert severity='success' onClose={a => setResponse(null)}>
            {response}
          </Alert>
        </Snackbar>
      </>
    )
}
